const PSEUDONYMS = {
  text: "Pseudonyms issued in this lecture",
  tooltipText: ` This is the number of students present in the class. Please check if
  the number of students matches the number of pseudonyms. If it
  doesn't, please click the RESET button.`,
};
const ACC_LECTURE = {
  text: "New accounts issued in this lecture",
  tooltipText: `This is the number of Private IDs issued in this lecture. The new Private IDs
  should be issued only to students that have not attended any of the
  previous lectures in this course. If the number of the new students
  doesn't match the number of new accounts, please click the RESET
  button.`,
};
const ACC_COURSE = {
  text: "New accounts issued in this course",
  tooltipText: `This is the number of Private IDs issued in all the lectures of this
  course. Before allowing new accounts, please check if any student has
  already received an Private ID in any of the previous lectures. If they
  did, they should use it to register to this course.`,
};
const REG_STUDENTS = {
  text: "Registered students in this course",
  tooltipText: `This is the number of students whose Private ID is registered for this
  course. Note that a student can receive an Private ID in any course and
  use it to register for this course. Before allowing new accounts,
  please check if any student has already received an Private ID.`,
};

export { ACC_COURSE, ACC_LECTURE, PSEUDONYMS, REG_STUDENTS };
